let map;
let activeMarker = null;
let infoWindow;
const markers = [];
let initialCenter;
let initialZoom;
let isSingleStoreView = false;
let storeCityUrl = '/pages/store-city';
const storefrontAccessToken = window.config?.storefrontAccessToken;
let userPosition = null;
let currentLocations = null;

function normalizeProvince(province) {
  if (!province) return province;
  if (province.trim().toUpperCase() === 'PM') return 'Palma de Mallorca';
  return province;
}

document.addEventListener('DOMContentLoaded', () => {

  const mapSection = document.querySelector('[data-section-type="map-address"], [data-section-type="store-location"]');
  if (!mapSection) return;

  const sectionType = mapSection.dataset.sectionType;
  isSingleStoreView = sectionType === 'store-location';

  if (!isSingleStoreView) {
    setupViewToggle(mapSection);
  }

  const apiKey = mapSection.dataset.apiKey;
  if (!apiKey) {
    console.error("Google Maps API Key no encontrada.");
    return;
  }

  if (typeof window.google === 'undefined' || typeof window.google.maps === 'undefined') {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMap&libraries=places`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    window.initMap = initMap;
  } else {
    initMap();
  }
});

function setupViewToggle(mapSection) {
  const mapLayout = mapSection.querySelector('.map-layout');
  const showMapBtn = mapSection.querySelector('#showMapBtn');
  const showStoresBtn = mapSection.querySelector('#showStoresBtn');

  if (mapLayout && showMapBtn && showStoresBtn) {
    showMapBtn.addEventListener('click', () => {
      mapLayout.dataset.view = 'map';
      showMapBtn.classList.add('active');
      showStoresBtn.classList.remove('active');
    });
    showStoresBtn.addEventListener('click', () => {
      mapLayout.dataset.view = 'stores';
      showStoresBtn.classList.add('active');
      showMapBtn.classList.remove('active');
    });
  }
}

async function initMap() {
  const mapSection = document.querySelector('[data-section-type="map-address"], [data-section-type="store-location"]');
  const mapElement = mapSection.querySelector('#map');
  const storesContainer = mapSection.querySelector('.map-sidebar__stores');
  const localeMatch = window.location.pathname.match(/^\/([a-z]{2}-[a-z]{2})\//i);
  storeCityUrl = localeMatch ? `/${localeMatch[1]}/pages/store-city` : '/pages/store-city';

  let locations;
  let locationsToShow;
  let targetStoreId = null;
  let targetCity = null;

  const urlParams = new URLSearchParams(window.location.search);

  if (isSingleStoreView) {
    targetStoreId = urlParams.get('id');

    if (!targetStoreId) {
      console.error("No se proporcionó un ID de tienda en la URL.");
      storesContainer.innerHTML = `<div class="no-results-message" style="display: block;"><p>${window.mapStrings.noStoreSpecified || 'No se especificó tienda'}</p></div>`;
      return;
    }

    locations = await getLocations()

    console.log('LOCATIONS', locations)
    if (!locations || locations.length === 0) {
      console.warn("No se encontraron ubicaciones de Shopify.");
      storesContainer.innerHTML = `<div class="no-results-message" style="display: block;"><p>${window.mapStrings.noStoreFound || 'No se encontraron tiendas'}</p></div>`;
      return;
    }
    const targetLocation = locations.find(loc => loc.name === targetStoreId);
    if (!targetLocation) {
      console.error(`Tienda con ID ${targetStoreId} no encontrada.`);
      storesContainer.innerHTML = `<div class="no-results-message" style="display: block;"><p>${window.mapStrings.noStoreExist || 'La tienda no existe'}</p></div>`;
      return;
    }

    locationsToShow = [targetLocation];

    // Single store-detail page: emit the full ClothingStore structured data.
    window.StructuredData?.buildStoreDetail(targetLocation);

    initialCenter = {
      lat: targetLocation.address.latitude,
      lng: targetLocation.address.longitude
    };
    initialZoom = 13;

    const nearbySection = document.querySelector('[data-section-type="nearby-stores"]');

    if (nearbySection) {
      initNearbyStores(nearbySection, locations)
    }

  } else {
    targetCity = urlParams.get('city');

    locations = await getLocations()

    if (!locations || locations.length === 0) {
      console.warn("No se encontraron ubicaciones de Shopify.");
      storesContainer.innerHTML = `<div class="no-results-message" style="display: block;"><p>${window.mapStrings.noStores || 'No hay tiendas disponibles'}</p></div>`;
      return;
    }

    if (targetCity) {
      const cityNormalized = targetCity.toLowerCase().trim();
      locationsToShow = locations.filter(loc => {
        const locationCity = loc.address?.city?.toLowerCase().trim();
        const locationProvince = normalizeProvince(loc.address?.province)?.toLowerCase().trim();
        return locationCity === cityNormalized || locationProvince === cityNormalized;
      });

      if (locationsToShow.length === 0) {
        console.warn(`No se encontraron tiendas en la ciudad: ${targetCity}`);
        storesContainer.innerHTML = `<div class="no-results-message" style="display: block;"><p>${window.mapStrings.noCityStores || 'No se encontraron tiendas en esta ciudad'}</p></div>`;
        return;
      }

      initialCenter = {
        lat: locationsToShow[0].address.latitude,
        lng: locationsToShow[0].address.longitude
      };
      initialZoom = 12;

      // ?city= store-locator page: emit a ClothingStore ItemList for the city.
      window.StructuredData?.buildCityStoresList(locationsToShow, { city: targetCity });
    } else {
      locationsToShow = locations;
      const customLat = parseFloat(mapSection.dataset.initialLat);
      const customLng = parseFloat(mapSection.dataset.initialLng);
      initialCenter = (customLat && customLng)
        ? { lat: customLat, lng: customLng }
        : { lat: locationsToShow[0].address.latitude, lng: locationsToShow[0].address.longitude };
      initialZoom = parseInt(mapElement.dataset.zoom) || 12;
    }

    const citySection = document.querySelector('.city-location-section');
    if (citySection) {
      const listContainer = citySection.querySelector('.city-location__list');
      buildCityList(locations, listContainer);
    }

    // On the main store-locator listing (no ?city filter), emit the
    // ItemList structured data from the loaded store data.
    if (!targetCity) {
      window.StructuredData?.buildStoreItemList(locations);
    }
  }

  currentLocations = locationsToShow;
  buildStoreCards(locationsToShow, storesContainer);
  const markersData = locationsToShow.map(location => ({
    id: location.name,
    lat: location.address.latitude,
    lng: location.address.longitude,
    title: location.name,
    address: `${location.address.address1}, ${location.address.zip}, ${location.address.city}`,
    phone: location.address.phone
  }));

  map = new google.maps.Map(mapElement, {
    zoom: initialZoom,
    center: initialCenter,
    mapTypeId: 'roadmap',
    disableDefaultUI: true,
    zoomControl: !isSingleStoreView,
    gestureHandling: isSingleStoreView ? 'none' : 'auto',
    clickableIcons: false,
    styles: getMapStyles()
  });

  infoWindow = new google.maps.InfoWindow({ pixelOffset: new google.maps.Size(0, 230) });

  const tempMarkers = [];
  let targetMarker = null;
  markersData.forEach(markerData => {
    const marker = createMarker(markerData);
    tempMarkers.push(marker)
    if (isSingleStoreView && markerData.id === targetStoreId) {
      targetMarker = marker;
    }
  });

  if (!isSingleStoreView) {
    new markerClusterer.MarkerClusterer({ // eslint-disable-line
      map, markers: tempMarkers,
      algorithm: new markerClusterer.SuperClusterAlgorithm({ // eslint-disable-line
        radius: 130
      }),
      renderer: {
        render: ({ count, position }) => {
          const svg = `
          <svg width="34" height="34" viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg">
            <style>
              .cluster-text { font-family: 'Montserrat', sans-serif; font-weight: 500; }
            </style>
            <circle cx="17" cy="17" r="16" fill="white" stroke="black" stroke-width="1"/>
            <text x="17" y="21" text-anchor="middle" class="cluster-text"
                  font-size="12" fill="black">${count}</text>
          </svg>
        `;

          return new google.maps.Marker({
            position,
            icon: {
              url: `data:image/svg+xml;base64,${btoa(svg)}`,
              scaledSize: new google.maps.Size(34, 34),
            },
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
          });
        }
      }
    });
  }
  setupEventListeners(mapSection);

  if (isSingleStoreView && targetMarker) {
    setTimeout(() => {
      new google.maps.event.trigger(targetMarker, 'click');
    }, 500);
  }
}

function parseAndFormatHours(hours) {
  if (!hours) {
    return '<p>Horario no disponible.</p>';
  }


  try {
    const hoursArray = JSON.parse(hours);
    const days = [
      window.mapStrings?.monday || 'Lunes',
      window.mapStrings?.tuesday || 'Martes',
      window.mapStrings?.wednesday || 'Miércoles',
      window.mapStrings?.thursday || 'Jueves',
      window.mapStrings?.friday || 'Viernes',
      window.mapStrings?.saturday || 'Sábado',
      window.mapStrings?.sunday || 'Domingo'
    ];

    let html = '';
    days.forEach((day, index) => {
      const hour = hoursArray[index] && hoursArray[index][0]
        ? hoursArray[index][0]
        : (window.mapStrings?.close || 'Cerrado');
      html += `<p><strong>${day}:</strong> <span>${hour}</span></p>`;
    });
    return html;
  } catch (e) {
    console.error(`Error al parsear JSON para ${location.name}:`, e);
    return '<p>Error al cargar el horario.</p>';
  }
}

function buildStoreCards(locations, container, showDistances = false) {
  let cardsHtml = '';

  locations.forEach(location => {
    const storeId = location.name;

    const { address1, city, zip, phone, countryCode } = location.address;
    const address = isSingleStoreView
      ? `${address1}, ${zip}, ${city}`
      : `${address1}, ${city}`;

    const distanceBadge = (showDistances && location.distance !== undefined)
      ? `<span class="store-item__distance">${formatDistance(location.distance)}</span>`
      : '';

    if (isSingleStoreView) {
      const scheduleHtml = parseAndFormatHours(location.address.hours);

      cardsHtml += `
        <div class="store-item" data-store-id="${storeId}" data-country-code="${(countryCode || '').toLowerCase()}">
          <div class="store-item__info">
            <h3 class="store-item__title">${window.mapStrings.brownieStore} ${location.name}</h3>
            <p class="store-item__address">${address}</p>
            ${phone ? `<p class="store-item__phone"><a href="tel:${phone}">${phone}</a></p>` : ''}
          </div>
          <div class="store-item__schedule">
            <h4>Horario</h4>
            <div class="schedule-days">
              ${scheduleHtml}
            </div>
          </div>
        </div>`;
    } else {
      cardsHtml += `
        <div class="store-item" data-store-id="${storeId}" data-country-code="${(countryCode || '').toLowerCase()}">
          ${distanceBadge}
          <h3 class="store-item__title">${location.name}</h3>
          <p class="store-item__address">${address}</p>
          ${phone ? `<p class="store-item__phone"><a href="tel:${phone}">${phone}</a></p>` : ''}
          <a href="${storeCityUrl}?id=${storeId}" class="store-item__directions">
            ${window.mapStrings?.viewDetails || 'Ver detalles'}
          </a>
        </div>`;
    }
  });

  if (isSingleStoreView) {
    container.innerHTML = cardsHtml;
  } else {
    container.insertAdjacentHTML('afterbegin', cardsHtml);
  }
}

function buildCityList(locations, container) {
  container.innerHTML = '';

  const currentCountry = window.config?.countryIsoCode;
  const filteredLocations = currentCountry
    ? locations.filter(loc => loc.address?.countryCode === currentCountry)
    : locations;

  const provinceCounts = {};
  filteredLocations.forEach(location => {
    const province = normalizeProvince(location.address?.province?.trim());

    if (province) {
      provinceCounts[province] = (provinceCounts[province] || 0) + 1;
    }
  });

  const sortedCities = Object.keys(provinceCounts).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

  if (sortedCities.length === 0) {
    container.innerHTML = '<p>No se encontraron tiendas.</p>';
    return;
  }

  sortedCities.forEach(province => {
    const count = provinceCounts[province];
    const cityParam = encodeURIComponent(province);
    const localizedRoot = window.Shopify?.routes?.root || '/';
    // Province listings live on the store locator itself; the old
    // /pages/tiendas-en-tu-ciudad page now redirects here.
    const baseUrl = `${localizedRoot}pages/localizacion-de-tiendas?city=`;

    const item = document.createElement('div');
    item.className = 'city-location__item';
    item.innerHTML = `
      <a href="${baseUrl}${cityParam}" class="city-location__link">
        ${province} (${count})
      </a>
    `;
    container.appendChild(item);
  });
}


function setupEventListeners(mapSection) {
  if (!isSingleStoreView) {
    const searchInputs = mapSection.querySelectorAll('#storeSearchInput, #storeSearchInputDesktop');
    const locationButtons = mapSection.querySelectorAll('#getLocationBtn, #getLocationBtnDesktop');

    const debouncedSearch = debounce(event => {
      const query = event.target.value;
      if (query.length > 2) {
        geocodeAddress(query);
      } else if (query.length === 0) {
        resetMap();
      }
    }, 500);

    searchInputs.forEach((input, index) => {
      const button = locationButtons[index];
      const locationIcon = button.querySelector('.icon-location');
      const clearIcon = button.querySelector('.icon-clear');
      const searchContainer = input.closest('.search-bar__container');

      const autocomplete = initializeAutocomplete(input);

      console.log(autocomplete)

      const toggleClearIcon = () => {
        const hasText = input.value.length > 0;
        locationIcon.style.display = hasText ? 'none' : 'block';
        clearIcon.style.display = hasText ? 'block' : 'none';
        button.title = hasText
          ? (window.mapStrings?.cleanSearch || 'Limpiar búsqueda')
          : (window.mapStrings?.findLocation || 'Usar mi ubicación');


        if (searchContainer) {
          if (hasText) {
            searchContainer.classList.add('has-value');
          } else {
            searchContainer.classList.remove('has-value');
          }
        }

      };

      input.addEventListener('input', debouncedSearch);
      input.addEventListener('keyup', toggleClearIcon);
      input.addEventListener('focus', toggleClearIcon);
      input.addEventListener('blur', () => {
        setTimeout(() => {
          if (input.value.length === 0) {
            toggleClearIcon();
          }
        }, 150);
      });

      button.addEventListener('click', (event) => {
        if (input.value.length > 0) {
          event.preventDefault();
          input.value = '';
          toggleClearIcon();
          resetMap();
          input.focus();
        } else {
          handleGeolocation(mapSection);
        }
      });
    });
  }

  map.addListener('click', () => {
    infoWindow.close();
    if (activeMarker) {
      activeMarker.setIcon(getCustomMarkerIcon());
      activeMarker = null;
    }
    document.querySelectorAll('.store-item').forEach(item => item.classList.remove('active'));
  });

  infoWindow.addListener('closeclick', () => {
    if (activeMarker) {
      activeMarker.setIcon(getCustomMarkerIcon());
      activeMarker = null;
    }
    document.querySelectorAll('.store-item').forEach(item => item.classList.remove('active'));
  });

  document.querySelector('.map-sidebar__stores').addEventListener('click', (event) => {

    if (event.target.closest('a')) return;

    const storeItem = event.target.closest('.store-item');
    if (storeItem) {
      const storeId = storeItem.dataset.storeId;
      const targetMarker = markers.find(m => m.id === storeId);
      if (targetMarker) {
        const showStoresBtn = document.querySelector('#showStoresBtn');
        const showMapBtn = document.querySelector('#showMapBtn');

        if (showStoresBtn && showStoresBtn.classList.contains('active')) {
          showMapBtn.click();
        }
        map.setCenter(targetMarker.getPosition());
        map.setZoom(14);
        new google.maps.event.trigger(targetMarker, 'click');
      }
    }
  });
}


function initializeAutocomplete(input) {
  const autocomplete = new google.maps.places.Autocomplete(input, {
    types: ['geocode'],
    componentRestrictions: { country: ['pt', 'es', 'fr', 'mx'] },
    fields: ['address_components', 'geometry', 'formatted_address']
  });

  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace();

    if (!place.geometry) {
      console.warn('No details available for input: ' + input.value);
      return;
    }

    if (place.geometry.viewport) {
      map.fitBounds(place.geometry.viewport);
    } else {
      map.setCenter(place.geometry.location);
      map.setZoom(15);
    }

    let locality = '';
    let countryCode = '';
    for (const component of place.address_components) {
      if (component.types.includes('locality')) locality = component.long_name;
      if (component.types.includes('country')) countryCode = component.short_name.toLowerCase();
    }

    const matched = filterStoreCards(locality || input.value, locality ? '' : countryCode);
    if (matched > 0) focusFirstStoreInList(!!(locality || countryCode));
  });

  return autocomplete;
}


function handleGeolocation(mapSection) {
  mapSection.classList.add('is-loading');

  if (!navigator.geolocation) {
    mapSection.classList.remove('is-loading');
    console.error("Error: Tu navegador no soporta geolocalización.");
    return;
  }

  // Add timeout option for iOS
  const options = {
    enableHighAccuracy: false, // Set to false for faster response on iOS
    timeout: 10000, // 10 second timeout
    maximumAge: 300000 // Accept 5-minute-old cached position
  };

  navigator.geolocation.getCurrentPosition(
    (position) => {
      userPosition = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      map.setCenter(userPosition);
      map.setZoom(15);
      mapSection.classList.remove('is-loading');
      updateStoreCardsWithDistances();
    },
    (error) => {
      mapSection.classList.remove('is-loading');

      // More detailed error handling
      let errorMessage = "No se pudo obtener tu ubicación.";

      switch (error.code) {
        case error.PERMISSION_DENIED:
          errorMessage = "Permiso de ubicación denegado. Por favor, habilita la ubicación en la configuración de tu navegador.";
          break;
        case error.POSITION_UNAVAILABLE:
          errorMessage = "Información de ubicación no disponible.";
          break;
        case error.TIMEOUT:
          errorMessage = "La solicitud de ubicación excedió el tiempo límite.";
          break;
      }

      console.error("Geolocation error:", error.code, error.message);
    },
    options // Add options object
  );
}

function resetMap() {
  if (map) {
    map.setCenter(initialCenter);
    map.setZoom(initialZoom);
  }
  document.querySelectorAll('.store-item').forEach(store => {
    store.style.display = 'block';
  });
  const noResultsMessage = document.querySelector('.no-results-message');
  if (noResultsMessage) noResultsMessage.style.display = 'none';
}

function geocodeAddress(address) {
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({ 'address': address }, (results, status) => {
    if (status === 'OK') {
      let locality = '';
      let countryCode = '';
      for (const component of results[0].address_components) {
        if (component.types.includes('locality')) locality = component.long_name;
        if (component.types.includes('country')) countryCode = component.short_name.toLowerCase();
      }
      const matched = filterStoreCards(locality || address, locality ? '' : countryCode);
      if (matched === 0 && locality) {
        const point = results[0].geometry.location;
        showStoresByDistance(point.lat(), point.lng());
      } else if (matched > 0) {
        const isNameSearch = locality && normalize(address).includes(normalize(locality)) && normalize(address) !== normalize(locality);
        focusFirstStoreInList(!isNameSearch && !!(locality || countryCode));
      } else {
        map.fitBounds(results[0].geometry.viewport);
      }
    } else {
      console.warn('Geocoding falló: ' + status);
      const matched = filterStoreCards(address, '');
      if (matched > 0) focusFirstStoreInList(false);
    }
  });
}

function showStoresByDistance(lat, lng) {
  const container = document.querySelector('.map-sidebar__stores');
  const noResultsMessage = container.querySelector('.no-results-message');
  const withDistance = currentLocations
    .map(loc => ({
      ...loc,
      distance: getDistanceInKm(lat, lng, loc.address.latitude, loc.address.longitude)
    }))
    .sort((a, b) => a.distance - b.distance);

  container.innerHTML = '';
  if (noResultsMessage) container.appendChild(noResultsMessage);
  noResultsMessage.style.display = 'none';
  buildStoreCards(withDistance, container, true);

  const nearest = withDistance[0];
  if (!nearest) return;

  const bounds = new google.maps.LatLngBounds();
  const nearby = withDistance.filter(loc => loc.distance <= nearest.distance + 5);
  nearby.forEach(loc => bounds.extend({ lat: loc.address.latitude, lng: loc.address.longitude }));

  if (nearby.length === 1) {
    map.setCenter({ lat: nearest.address.latitude, lng: nearest.address.longitude });
    map.setZoom(14);
  } else {
    map.fitBounds(bounds);
  }
}

function scrollToStoreItem(storeId) {
  const storeItem = document.querySelector(`.store-item[data-store-id="${storeId}"]`);
  const storesContainer = document.querySelector('.map-sidebar__stores');

  if (storeItem && storesContainer) {
    const containerRect = storesContainer.getBoundingClientRect();
    const itemRect = storeItem.getBoundingClientRect();

    const scrollTop = storesContainer.scrollTop + (itemRect.top - containerRect.top) - (containerRect.height / 2) + (itemRect.height / 2);

    storesContainer.scrollTo({
      top: scrollTop,
      behavior: 'smooth'
    });
  }
}

function focusFirstStoreInList(fitAll = false) {
  const visibleStores = Array.from(document.querySelectorAll('.store-item'))
    .filter(s => s.style.display !== 'none');
  if (!visibleStores.length) return;

  const visibleMarkers = visibleStores
    .map(s => markers.find(m => m.id === s.dataset.storeId))
    .filter(Boolean);
  if (!visibleMarkers.length) return;

  if (fitAll) {
    const bounds = new google.maps.LatLngBounds();
    visibleMarkers.forEach(m => bounds.extend(m.getPosition()));
    map.fitBounds(bounds);
    return;
  }

  const firstPos = visibleMarkers[0].getPosition();
  const nearby = visibleMarkers.filter(m => {
    const p = m.getPosition();
    return getDistanceInKm(firstPos.lat(), firstPos.lng(), p.lat(), p.lng()) <= 5;
  });

  if (nearby.length === 1) {
    map.setCenter(firstPos);
    map.setZoom(14);
  } else {
    const bounds = new google.maps.LatLngBounds();
    nearby.forEach(m => bounds.extend(m.getPosition()));
    map.fitBounds(bounds);
  }
}

function normalize(str) {
  return (str || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
}

function filterStoreCards(searchTerm, countryCode = '') {
  const stores = document.querySelectorAll('.store-item');
  const noResultsMessage = document.querySelector('.no-results-message');
  let visibleCount = 0;
  const term = normalize(searchTerm);
  const code = (countryCode || '').toLowerCase().trim();

  if (!term && !code) {
    stores.forEach(store => { store.style.display = 'none' });
  } else {
    stores.forEach(store => {
      const addressElement = store.querySelector('.store-item__address');
      const titleElement = store.querySelector('.store-item__title');
      const cityMatch = term && addressElement && normalize(addressElement.textContent).includes(term);
      const nameMatch = term && titleElement && normalize(titleElement.textContent).includes(term);
      const countryMatch = code && store.dataset.countryCode === code;
      if (cityMatch || nameMatch || countryMatch) {
        store.style.display = 'block';
        visibleCount++;
      } else {
        store.style.display = 'none';
      }
    });
  }

  if (visibleCount === 0 && (term !== '' || code !== '')) {
    noResultsMessage.style.display = 'block';
  } else {
    noResultsMessage.style.display = 'none';
  }
  return visibleCount;
}

function debounce(func, delay) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

function createMarker(markerData) {
  const marker = new google.maps.Marker({
    position: { lat: markerData.lat, lng: markerData.lng },
    map: map,
    title: markerData.title,
    icon: getCustomMarkerIcon(),
    id: markerData.id,
    storeData: markerData
  });

  markers.push(marker);

  marker.addListener('click', () => {
    if (activeMarker) activeMarker.setIcon(getCustomMarkerIcon());
    marker.setIcon(getCustomMarkerIconSelected());
    activeMarker = marker;

    const targetZoom = 15;
    if (map.getZoom() < targetZoom) {
      map.setZoom(targetZoom);
    }

    map.panTo(marker.getPosition());
    document.querySelectorAll('.store-item').forEach(item => {
      item.classList.toggle('active', item.dataset.storeId === marker.id);
    });
    if (!isSingleStoreView) {
      openInfoWindow(marker);
    }
    scrollToStoreItem(marker.id);
  });

  return marker;
}

function openInfoWindow(marker) {
  const contentString = `
    <div class="custom-infowindow">
      <div class="custom-infowindow__content">
        <p class="custom-infowindow__title">${marker.storeData.title}</p>
        <p class="custom-infowindow__address">${marker.storeData.address}</p>
        <p class="custom-infowindow__phone"><a href="tel:${marker.storeData.phone}">${marker.storeData.phone}</a></p>
        <a href="${storeCityUrl}?id=${marker.storeData.id}" class="custom-infowindow__button">
          ${window.mapStrings?.viewDetails || 'Ver detalles'}
        </a>
      </div>
    </div>`;
  infoWindow.setContent(contentString);


  infoWindow.open(map, marker);

  google.maps.event.addListenerOnce(infoWindow, 'domready', () => {
    const isDesktop = window.innerWidth >= 1024; // Adjust breakpoint as needed

    if (isDesktop) {
      const infoWindowElement = document.querySelector('.gm-style-iw-c');

      if (infoWindowElement) {
        const infoWindowHeight = infoWindowElement.offsetHeight;
        const markerHeight = 63;
        const desiredGap = 16;

        // Calculate offset: infoWindow height + marker height + gap
        const offset = (infoWindowHeight + markerHeight + desiredGap);

        infoWindow.setOptions({
          pixelOffset: new google.maps.Size(0, offset)
        });
      }
    }
  });

}

function getMapStyles() {
  return [
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{ visibility: 'on' }]
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{ color: '#E7E5DB' }]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#CDD7E2' }]
    },
    {
      featureType: 'poi.attraction',
      elementType: 'labels.icon',
      stylers: [{ color: '#D5CBE1' }]
    },
    {
      featureType: 'poi',
      elementType: 'labels.icon',
      stylers: [{ color: '#CDD7E2' }]
    },
    {
      featureType: 'poi.attraction',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#6E5A8D' }]
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#789A8C' }]
    },
    {
      featureType: 'transit',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'road',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ visibility: 'off' }]
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels',
      stylers: [{ visibility: 'on' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'labels',
      stylers: [{ visibility: 'on' }]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#FFFFFF' }]
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#D4D1C5', weight: 0.5 }]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{ color: '#F5F3ED' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#C9C5B8', weight: 0.8 }]
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#9B9384', weight: 1 }]
    },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.icon',
      stylers: [{ color: '#F1A2BB' }]
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'all',
      stylers: [{ color: '#F5F3F3' }]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#CEDEFC' }]
    },
  ];
}

async function initNearbyStores(section, locations) {
  const listContainer = section.querySelector('.nearby-stores__list');
  const radiusKm = parseInt(section.dataset.radiusKm, 10);
  const maxStores = parseInt(section.dataset.maxStores, 10);

  const urlParams = new URLSearchParams(window.location.search);
  const storeId = urlParams.get('id');

  if (!storeId) {
    listContainer.innerHTML = '<p>No se ha especificado una tienda de referencia.</p>';
    return;
  }

  if (!locations || locations.length === 0) {
    listContainer.innerHTML = '<p>No se pudieron cargar las tiendas.</p>';
    return;
  }

  const targetLocation = locations.find(loc => loc.name === storeId);
  if (!targetLocation) {
    listContainer.innerHTML = '<p>No se encontró la tienda de referencia.</p>';
    return;
  }

  const targetPoint = {
    lat: targetLocation.address.latitude,
    lng: targetLocation.address.longitude,
  };

  const nearbyStores = getStoresWithinRadius(targetPoint, locations, radiusKm);

  nearbyStores.sort((a, b) => a.distance - b.distance);
  const storesToShow = nearbyStores.slice(0, maxStores);

  if (storesToShow.length > 0) {
    buildNearbyList(storesToShow, listContainer);
  } else {
  }
}

function buildNearbyList(stores, container) {
  let listHtml = '';
  stores.forEach(store => {
    const storeUrl = `${storeCityUrl}?id=${store.name}`;

    const address = `${store.address.address1}, ${store.address.zip}, ${store.address.city}`

    listHtml += `
      <div class="nearby-store-item">
        <a href="${storeUrl}" class="nearby-store-item__title">${store.name.replace(/^Brownie\s*-\s*/i, '')}</a>
        <p class="nearby-store-item__address">${address}</p>
        ${store.address.phone ? `<p class="nearby-store-item__phone"><a href="tel:${store.address.phone}">${store.address.phone}</a></p>` : ''}
      </div>
    `;
  });
  container.innerHTML = listHtml;
}

function getStoresWithinRadius(targetPoint, allStores, radiusKm) {
  return allStores
    .map(store => {
      if (store.address.latitude === targetPoint.lat && store.address.longitude === targetPoint.lng) {
        return null;
      }
      const distance = getDistanceInKm(
        targetPoint.lat,
        targetPoint.lng,
        store.address.latitude,
        store.address.longitude
      );
      return { ...store, distance };
    })
    .filter(store => store && store.distance <= radiusKm);
}

function toRad(degrees) {
  return degrees * (Math.PI / 180);
}

function getDistanceInKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

function formatDistance(km) {
  if (km < 1) {
    return `${Math.round(km * 1000)} m`;
  }
  return `${Math.round(km)} km`;
}

function updateStoreCardsWithDistances() {
  if (!userPosition || !currentLocations || isSingleStoreView) return;

  const locationsWithDistance = currentLocations.map(location => ({
    ...location,
    distance: getDistanceInKm(
      userPosition.lat, userPosition.lng,
      location.address.latitude, location.address.longitude
    )
  }));

  locationsWithDistance.sort((a, b) => a.distance - b.distance);

  const container = document.querySelector('.map-sidebar__stores');
  const noResultsMessage = container.querySelector('.no-results-message');
  container.innerHTML = '';
  if (noResultsMessage) {
    container.appendChild(noResultsMessage);
  }
  buildStoreCards(locationsWithDistance, container, true);
  focusFirstStoreInList();
}

function getCustomMarkerIcon() {
  return {
    url: `data:image/svg+xml,${encodeURIComponent(
      `<svg width="36" height="50" viewBox="0 0 36 50" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.05718 22.7333C5.26872 30.5325 13.7288 43.4604 18.3571 48.6925C22.5831 42.4542 31.6386 28.5288 34.0534 22.7333C37.575 14.2815 31.0349 1 18.3571 1C6.8868 1 -2.16885 12.4703 2.05718 22.7333Z" fill="white" stroke="#2A2A2A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16.1699 11.018H17.4966C19.6389 11.018 20.6652 12.2771 20.6652 15.2534C20.6652 17.8698 19.0393 18.8659 17.5291 18.8659H16.1699V11.018ZM16.1699 19.3321H17.6982C19.9368 19.3321 21.2167 21.0002 21.2167 23.7216C21.2167 26.8493 19.8652 28.1668 17.3145 28.1668H16.1699V19.3321ZM10.5625 28.625H18.3044C22.9726 28.625 25.4375 26.5186 25.4375 23.6923C25.4375 20.6151 22.7307 18.9788 19.2838 18.9788V18.9191C21.6966 18.7185 24.4333 17.5697 24.4333 14.8125C24.4333 11.8362 21.3936 10.5625 18.5801 10.5625H10.5625V11.018H12.2534V28.1668H10.5625V28.625Z" fill="#2A2A2A"/></svg>`
    )}`,
    scaledSize: new google.maps.Size(34, 47.69),
    anchor: new google.maps.Point(18, 50)
  };
}

function getCustomMarkerIconSelected() {
  return {
    url: `data:image/svg+xml,${encodeURIComponent(
      `<svg width="34" height="48" viewBox="0 0 34 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.05718 21.7333C4.26872 29.5325 12.7288 42.4604 17.3571 47.6925C21.5831 41.4542 30.6386 27.5288 33.0534 21.7333C36.575 13.2815 30.0349 0 17.3571 0C5.8868 0 -3.16885 11.4703 1.05718 21.7333Z" fill="#2A2A2A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.1699 10.018H16.4966C18.6389 10.018 19.6652 11.2771 19.6652 14.2534C19.6652 16.8698 18.0393 17.8659 16.5291 17.8659H15.1699V10.018ZM15.1699 18.3321H16.6982C18.9368 18.3321 20.2167 20.0002 20.2167 22.7216C20.2167 25.8493 18.8652 27.1668 16.3145 27.1668H15.1699V18.3321ZM9.5625 27.625H17.3044C21.9726 27.625 24.4375 25.5186 24.4375 22.6923C24.4375 19.6151 21.7307 17.9788 18.2838 17.9788V17.9191C20.6966 17.7185 23.4333 16.5697 23.4333 13.8125C23.4333 10.8362 20.3936 9.5625 17.5801 9.5625H9.5625V10.018H11.2534V27.1668H9.5625V27.625Z" fill="white"/></svg>`
    )}`,
    scaledSize: new google.maps.Size(34, 47.69),
    anchor: new google.maps.Point(17, 48)
  };
}

async function getLocations() {
  let locations;
  // Use the store API to get locations (either from API or local fallback)
  if (window.storeApi && typeof window.storeApi.getStoreLocations === 'function') {
    locations = await window.storeApi.getStoreLocations();
  } else {
    // Fallback if store-api.js is not loaded
    console.warn('[Store Locator] store-api.js not loaded, using local data');
    locations = window.storeLocations || [];
  }

  return applyDevoFilter(locations);
}

// When the URL has ?devo=true, exclude third-party / outlet points of sale
// (El Corte Inglés / ECI / La Roca / Aeropuerto / Rozas) from the map and the listings.
function applyDevoFilter(locations) {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('devo') !== 'true' || !Array.isArray(locations)) {
    return locations;
  }

  const excluded = [/\bel corte ingles\b/, /\beci\b/, /\bla roca\b/, /\baeropuerto\b/, /\brozas\b/];
  return locations.filter(loc => {
    const haystack = normalize([
      loc.name,
      loc.address?.address1,
      loc.address?.city
    ].filter(Boolean).join(' '));
    return !excluded.some(re => re.test(haystack));
  });
}
